import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import uuid from "react-uuid";

import { makeStyles } from "@mui/styles";
import {
  AutocompleteInput,
  DateInput,
  FloatInput,
  TextInput,
} from "components/Input/Index.js";

import CreateButton from "components/CustomButtons/CreateButton.js";

import { compte } from "variables/patrimoine.js";

import AdvancedSearchContext from "context/AdvancedSearchContext";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { updateAccountContract, getFiles } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function AddUtilitiesDialog(props) {
  const [disabled, setDisabled] = useState(true);
  const [clef, setClef] = useState();
  const [contractname, setContractname] = useState();
  const [contractnumber, setContractnumber] = useState();
  const [tarifftype, setTarifftype] = useState();
  const [name, setName] = useState();
  const [contractbegindate, setContractbegindate] = useState();
  const [contractenddate, setContractenddate] = useState();
  const [billowner, setBillowner] = useState();
  const [contractowner, setContractowner] = useState();
  const [payedby, setPayedby] = useState();
  const [primaryfinalenergyratio, setPrimaryfinalenergyratio] = useState();
  const [co2ratio, setCo2ratio] = useState();
  const [energycost, setEnergycost] = useState();
  const [othermonthlycost, setOthermonthlycost] = useState();
  const [otherunitcost, setOtherunitcost] = useState();
  const [comments, setComments] = useState();
  const [description, setDescription] = useState();
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const [ged, setGed] = useState([]);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch, energy, parameters, deleteCounter } = props;

  const handleClefChange = (e) => {
    setClef(e.target.value);
  };
  const handleContractnameChange = (e) => {
    setContractname(e.target.value);
  };
  const handleContractnumberChange = (e) => {
    setContractnumber(e.target.value);
  };
  const handleTariftypeChange = (e) => {
    setTarifftype(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleContractbegindateChange = (e) => {
    setContractbegindate(e.target.value);
  };
  const handleContractenddateChange = (e) => {
    setContractenddate(e.target.value);
  };
  const handleBillownerChange = (e) => {
    setBillowner(e.target.value);
  };
  const handleContractownerChange = (e) => {
    setContractowner(e.target.value);
  };
  const handlePayedbyChange = (e) => {
    setPayedby(e.target.value);
  };
  const handlePrimaryfinalenergyratioChange = (e) => {
    setPrimaryfinalenergyratio(e.target.value);
  };
  const handleCo2ratioChange = (e) => {
    setCo2ratio(e.target.value);
  };
  const handleEnergycostChange = (e) => {
    setEnergycost(e.target.value);
  };

  const handleOthermonthlycostChange = (e) => {
    setOthermonthlycost(e.target.value);
  };
  const handleOtherunitcostChange = (e) => {
    setOtherunitcost(e.target.value);
  };
  const handleAssociatedfilesChange = (newValue) => {
    setGed(newValue);
  };
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;

    if (ged !== undefined) {
      for (let i = 0; i < ged.length; i++) {
        gedCardId.push(ged[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };


  useEffect(() => {
    if (!name || !contractname) {
      setDisabled(true);
    }
    else
      setDisabled(false);
  }, [name, contractname]);

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const handleSubmit = async (event) => {
    const editedDetails = {
      clef,
      contractname,
      contractnumber,
      tarifftype,
      name,
      contractbegindate,
      contractenddate,
      billowner,
      contractowner,
      payedby,
      primaryfinalenergyratio,
      co2ratio,
      energycost,
      othermonthlycost,
      otherunitcost,
      comments,
      description,
      ged,
    };

    const editedContract = {
      'uuid': uuid(),
      details: editedDetails,
    };

    axios
      .post(
        updateAccountContract(editedContract.uuid, chartIdGroup, energy),
        editedContract,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
        deleteCounter();
      })
      .catch(() => { });
  };

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={compte.energy[energy][parameters].contractname}
                textInput={contractname}
                handleTextInputChange={handleContractnameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].contractnumber}
                textInput={contractnumber}
                handleTextInputChange={handleContractnumberChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].tarifftype}
                textInput={tarifftype}
                handleTextInputChange={handleTariftypeChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={compte.energy[energy][parameters].name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.energy[energy][parameters].contractbegindate}
                dateInput={contractbegindate}
                handleDateInputChange={handleContractbegindateChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.energy[energy][parameters].contractenddate}
                dateInput={contractenddate}
                handleDateInputChange={handleContractenddateChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].billowner}
                textInput={billowner}
                handleTextInputChange={handleBillownerChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].contractowner}
                textInput={contractowner}
                handleTextInputChange={handleContractownerChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].payedby}
                textInput={payedby}
                handleTextInputChange={handlePayedbyChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={
                  compte.energy[energy][parameters].primaryfinalenergyratio
                }
                floatInput={primaryfinalenergyratio}
                handleFloatInputChange={handlePrimaryfinalenergyratioChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].co2ratio}
                floatInput={co2ratio}
                handleFloatInputChange={handleCo2ratioChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].energycost}
                floatInput={energycost}
                handleFloatInputChange={handleEnergycostChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].othermonthlycost}
                floatInput={othermonthlycost}
                handleFloatInputChange={handleOthermonthlycostChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].otherunitcost}
                floatInput={otherunitcost}
                handleFloatInputChange={handleOtherunitcostChange}
              />
            </div>
            <div>
              <AutocompleteInput
                specialWidth="97%"
                inputTitle={compte.energy[energy][parameters].associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={disabled} handleSubmit={handleSubmit} />
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddUtilitiesDialog;
